import React, {useState} from "react" ;
import {Route, Switch} from "react-router-dom";

import AppSidebarMenuItem from "../../Common/Sidebar/AppSidebarMenuItem";
import AppSidebarGroup from "../../Common/Sidebar/AppSidebarGroup";
import ResourcesSubmenu from "./ResourcesSubmenu";
import {PATH_RESOURCES_ROOT, getResourcesRouterLink} from "root/Wieldy/routePaths";
import ScrollRails from "root/Wieldy/ApplicationModules/Common/Body/ScrollRails";
import AppSidebarHeader from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarHeader";

const ResourcesAppSidebar= (props) =>
{
    return (
        <div className="dt-module__sidebar">

            <AppSidebarHeader iconName={props.iconName} title={props.title} />

            <div className="dt-module__sidebar-content ps-custom-scrollbar ps" style={{height: props.height}}>

                <ul className="dt-module-side-nav">

                    <AppSidebarGroup title='View' default='resources'>
                        <AppSidebarMenuItem link={getResourcesRouterLink('resources?type=feelings')} title='Resources' iconName='icon-files' name='resources' />
                    </AppSidebarGroup>

                    <Switch>
                        <Route path={PATH_RESOURCES_ROOT} render={(thisprops) => <ResourcesSubmenu {...thisprops}/>}/>
                        <Route exact path={PATH_RESOURCES_ROOT} render={(thisprops) => <ResourcesSubmenu {...thisprops}/>}/>
                    </Switch>

                </ul>

                <ScrollRails />

            </div>

        </div>
    ) ;
}

export default ResourcesAppSidebar;
